import React from "react";
import { useSelector } from "react-redux";
import { LOCALES } from "../lang";

const ChevronIcon = ({ width, height, color = "currentColor" }) => {
  const locale = useSelector(({ theme }) => theme.locale);

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      className="bi bi-chevron-right"
      viewBox="0 0 16 16"
      width={width}
      height={height}
      transform={locale === LOCALES.ARABIC ? "scale(-1,1)" : "scale(1,1)"}
    >
      <path
        stroke={color}
        strokeWidth="2"
        fillRule="evenodd"
        d="M4.646 1.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708L10.293 8 4.646 2.354a.5.5 0 0 1 0-.708z"
      />
    </svg>
  );
};

export default ChevronIcon;
